module.exports = __webpack_public_path__ + "media/images/pc/stores/common/icon_woman-2649926cca618ae45b5e499863f1d0fd.png";